import { Box, Typography } from '@mui/material';
import typography from '../../styles/typography.module.css';

import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';

export const Sensitivity = ({ model, sensitivity }) => {
    const { t } = useTranslation();
    const sensetivityInfo = t(`${model}.sensitivity`);
    const info =
        sensetivityInfo.localeCompare(`${model}.sensitivity`) === 0 || sensetivityInfo === undefined
            ? sensitivity
            : sensetivityInfo;
    return (
        <Box className={layout.subSectionContainer} style={{ width: '100%' }}>
            <Typography>
                <span className={typography.modelDescriptionSubTitle}>
                    {t('model.sensitivity')}:{' '}
                </span>
                <span className={typography.modelDescription}> {info} </span>
            </Typography>
        </Box>
    );
};
